<template>
  <div>
    <router-link
            :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
            class="member-name"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.proposal.publish.by.multiple.consolidated.p1')}} <a
      class="news-proposers-popup"
      :data-href="`/riksdagen/proposal/proposers/${news.textParams[5]}`"
      href="#"
      @click.prevent="updateConsolidatedNewsList(news.stringChildIds)"
    >{{news.textParams[6]}}
      {{$t('news.template.proposal.publish.by.multiple.consolidated.p2')}}</a>
    {{$t('news.template.proposal.publish.by.multiple.consolidated.p3')}} <a
      class="consolidated-news"
      href="#"
      @click.prevent="updateConsolidatedNewsList(news.stringChildIds)"
    >{{news.textParams[2]}}
      {{$t('news.template.proposal.publish.by.multiple.consolidated.p4')}}</a>
    {{$t('news.template.proposal.publish.by.multiple.consolidated.p5')}}
    <router-link
      :to="{name: 'forum', params: {id: news.textParams[3]}}"
    >{{ news.textParams[4] }}
    </router-link>
  </div>
</template>

<script>
import { mapActions } from "pinia";
import { newsStore } from "@/store/newsStore";

export default {
  props: {
    news: {
      type: Object,
    },
  },
  methods: {
    ...mapActions(newsStore, ['updateConsolidatedNewsList']),
  },
};
</script>
